import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TrafficIcon16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#3379BD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6 5.712v7.619M2.667 8.759v4.572M9.334 2.664v10.667m3.333-7.62v7.62"
    />
  </Svg>
);
export default TrafficIcon16;
